export default __webpack_public_path__ + "static/media/Governance.fbf6e7a6.svg";